import React from 'react';

const advisoryCommittee = [
  {
    sno: 1,
    name: "Prof. Haiming Liu",
    institute: "Director of the Centre of Machine Intelligence, University of Southampton, England"
  },
  {
    sno: 2,
    name: "Prof. Lalit Garg",
    institute: "Professor, Computer Information Systems | Faculty of Information and Communication Technology at the University of Malta, Malta, Europe"
  },
  {
    sno: 3,
    name: "Prof. Vipin Baliyan",
    institute: "NRF Rated Researcher, DEECE, Cape Peninsula University of Technology, Cape Town, South Africa"
  },
  {
    sno: 4,
    name: "Prof. Varadaj Prabhu Gurupur",
    institute: "School of Global Health Management and Informatics, University of Central Florida"
  },
  {
    sno: 4,
    name: "Prof. Animesh Yadava",
    institute: "School of Electrical Engineering and Computer Science, Ohio University, USA"
  },
  {
    sno: 4,
    name: "Prof. Gunjan Gupta",
    institute: "Senior Lecturer, Cape Peninsula University of Technology, Cape Town, Western Cape, South Africa"
  },
  {
    sno: 4,
    name: "Prof. Ajay Sharma",
    institute: "European Union (Belgium), Marie Skłodowska-Curie Actions (MSCA) Framework, Belgium, European Union"
  },
  {
    sno: 4,
    name: "Prof. Kulbir Singh",
    institute: "Thapar University, Patiala"
  },
  {
    sno:4,
    name: "Prof. Hem Dutt Joshi",
    institute: "Thapar University, Patiala"
  },
  {
    sno:4,
    name: "Prof. Ankush Kansal",
    institute: "Thapar University, Patiala"
  },
  {
    sno:4,
    name: "Prof. Anil Verma",
    institute: "Thapar University, Patiala"
  },
  {
    sno:4,
    name: "Prof. Moon Inder Singh",
    institute: "Thapar University, Patiala"
  },
  {
    sno:4,
    name: "Prof. Ajay Kakkar",
    institute: "Thapar University, Patiala"
  },
  {
    sno:4,
    name: "Prof. Neeru Jindal",
    institute: "Thapar University, Patiala"
  },
  {
    sno:4,
    name: "Prof. Balwinder Raj",
    institute: "NIT Jalandhar"
  },
  {
    sno:4,
    name: "Prof. Ashwani K Rana",
    institute: "NIT Hamirpur"
  },
  {
    sno:4,
    name: "Prof. Manoj Mittal",
    institute: "IKGPTU Jalandhar"
  },
  {
    sno:4,
    name: "Prof. Sharad Sharma",
    institute: "MMU Mullana"
  },
  {
    sno:4,
    name: "Prof. Davinder Kumar Saini",
    institute: "CCET, Sec-26, Chandigarh"
  },
  {
    sno:4,
    name: "Prof. Gitanjali",
    institute: "Chitkara University, Rajpura"
  },
  {
    sno:4,
    name: "Prof. Ramanpreet Kaur",
    institute: "CGC LanProfan, Mohali, Punjab"
  },
  {
    sno:4,
    name: "Prof. Sharat Tiwari",
    institute: "Parul University, Vadodara, Gujarat"
  },
  {
    sno:4,
    name: "Prof. Reenuka Sharma",
    institute: "SGT, University"
  },
  {
    sno:4,
    name: "Prof. Poonam",
    institute: "PEC, Chandigarh"
  },
  {
    sno:4,
    name: "Prof. Simranjeet Singh",
    institute: "PEC, Chandigarh"
  },
  {
    sno: 4,
    name: "Prof. Ruchita Gautam",
    institute: "KIET, Ghaziabad"
  },
  {
    sno: 5,
    name: "Prof. Praveen Kaushik",
    institute: "KIET, Ghaziabad"
  },
  {
    sno: 6,
    name: "Prof. Shubham Shukla",
    institute: "IIIT Pune"
  },
  {
    sno: 7,
    name: "Prof. Priya Ranjan",
    institute: "UPES, Dehradun"
  },
  {
    sno: 8,
    name: "Prof. Manoj Sindhwani",
    institute: "LPU, Jalandhar"
  },
  {
    sno: 9,
    name: "Prof. Abhas Kanungo",
    institute: "KIET, Ghaziabad"
  },
  {
    sno: 10,
    name: "Prof. Rochak Bajpai",
    institute: "UPES, Dehradun"
  },
  {
    sno: 11,
    name: "Prof. Preeti Sharma",
    institute: "Chitkara University, Rajpura"
  },
  
];

const Advisory = () => {
  return (
    <div>
      {/* Technical Program Community */}
      <div className='container mx-auto p-4 pt-20 sm:pt-4'>
        <div className="flex flex-wrap w-full relative flex-col flex-auto py-8 px-9">
          <h1 className="mb-2 text-[1.75rem] font-bold text-dark text-center text-4xl uppercase">
          Advisory Committee
          </h1>
        </div>
        <div className="flex w-full text-2xl">
          <ul className="list-disc pl-5 ">
            {advisoryCommittee.map((member, index) => (
              <li key={index} className="text-lg sm:text-2xl mb-4">
                {member.name}, {member.institute}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Advisory;